import { render, staticRenderFns } from "./DeleteCharge.vue?vue&type=template&id=374f7690&"
import script from "./DeleteCharge.vue?vue&type=script&lang=js&"
export * from "./DeleteCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeleteCharge.vue"
export default component.exports